import { useDrag } from "react-dnd";
import Icon1 from "../../icons/Icon";
import Tippy from "@tippyjs/react";

function SidebarDraggableField({ field, type }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "FIELD",
    item: { type: type, name: field },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <Tippy
      content="Attrapez le champ pour le déplacer"
      delay={500}
      className="custom-tooltip"
    >
      <div
        ref={drag}
        className="p-2 w-full hover:shadow-lg active:bg-blue-300 active:opacity-50 active:border-2 active:border-black active:border-dashed text-h3 flex flex-row justify-between bg-white rounded-lg cursor-grab  border-1 border-shadow_25"
        style={{
          opacity: isDragging ? 0.7 : 1,
        }}
      >
        {field}
        <div className=" rounded-full p-1">
          <Icon1 icon_name="curseur-main" fill="grey" size={20} />
        </div>
      </div>
    </Tippy>
  );
}

export default SidebarDraggableField;
